import React from 'react';
import { cn } from '../../lib/cn';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export interface SectionCardProps {
  title?: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  meta,
  actions,
  className,
  contentClassName,
  children,
}) => (
  <Card className={cn(className)}>
    {(title || meta || actions) && (
      <CardHeader>
        <div>
          {title ? <CardTitle>{title}</CardTitle> : null}
          {meta ? <CardDescription className="mt-1">{meta}</CardDescription> : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </CardHeader>
    )}
    <CardContent className={cn((title || meta || actions) ? '' : 'pt-4', contentClassName)}>{children}</CardContent>
  </Card>
);
